import Vue from 'vue'
import Router from 'vue-router'
import storage from "../api/storage";
import HelloWorld from '@/components/HelloWorld'
import versionTood from '@/api/versionUpdate'


import Login from '@/page/Login'
import Main from '@/page/Main'
import Index from '@/page/Index'
import ShowSet from '@/page/ShowSet'
import ShowData from '@/page/ShowData'
import Logistics from '@/page/Logistics'
import SellerMemo from '@/page/SellerMemo'
import Delay from '@/page/Delay'
import Close from '@/page/Close'
import BeiHuo from "@/page/BeiHuo"
import Item from '@/page/Item'
import Sku from '@/page/Sku'
import Permission from '@/page/Permission'
import Help from '@/page/Help'
import Custom from '@/custom/Custom'
import GaoDeng from '@/custom/GaoDeng'
import GaoYao from '@/custom/GaoYao'
import JingChu from '@/custom/JingChu'
import QianShu from '@/custom/QianShu'
import ManKa from '@/custom/ManKa'
import Tjfzz from '@/custom/Tjfzz'
import ItmFull from '@/custom/ItmFull'
import SkuFull from '@/custom/SkuFull'
import Love from '@/custom/Love'

import Wlb from '@/page/Wlb'
import Bind from '@/page/Bind'
import Outer from '@/page/Outer'
import PrintMd from '@/print/PrintMd'
import KddTemp from '@/print/KddTemp'
import Design from '@/print/Design'
import Print from '@/print/Print'
import Free from '@/print/Free'
import Address from '@/print/Address'
import ShowPrint from '@/print/ShowPrint'

import ModiSku from '@/page/ModiSku'
import Refund from '@/page/Refund'

import AdmLogin from '@/admin/AdmLogin'
import AdmMain from '@/admin/AdmMain'
import AdmAccess from '@/admin/AdmAccess'
import AdmSmsLog from '@/admin/AdmSmsLog'
import AdmOuter from '@/admin/AdmOuter'

import Material from '@/jxc/Material'
import JxcItem from '@/jxc/JxcItem'
import JxcSku from '@/jxc/JxcSku'

import AutoSend from '@/auto/AutoSend'
import MemoLog from '@/auto/MemoLog'
import SendItem from '@/auto/SendItem'

import AutoMemo from '@/auto/AutoMemo'

Vue.use(Router)

//v-wechat-title='$route.meta.title'

const router = new Router({
//export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/Help2',
      name: 'Help2',
      component: Help,
    },

    {
      path: '/AdmLogin',
      name: 'AdmLogin',
      component: AdmLogin,
    },

    {
      path: '/AdmMain',
      name: 'AdmMain',
      component: AdmMain,
      children:[
        {
          path: '/AdmAccess',
          name: 'AdmAccess',
          component: AdmAccess,
        },
        {
          path: '/AdmSmsLog',
          name: 'AdmSmsLog',
          component: AdmSmsLog,
        },
        {
          path: '/AdmOuter',
          name: 'AdmOuter',
          component: AdmOuter,
        },
      ]
    },

    {
      path: '/Main',
      name: Main,
      component: Main,

      children:[
        {
          path: '/Index',
          name: 'Index',
          component: Index,
        },
        {
          path: '/ShowSet',
          name: 'ShowSet',
          component: ShowSet,
        },
        {
          path: '/ShowData',
          name: 'ShowData',
          component: ShowData,
        },
        {
          path: '/Logistics',
          name: 'Logistics',
          component: Logistics,
        },
        {
          path: '/SellerMemo',
          name: 'SellerMemo',
          component: SellerMemo,
        },
        {
          path: '/Delay',
          name: 'Delay',
          component: Delay,
        },
        {
          path: '/Close',
          name: 'Close',
          component: Close,
        },
        {
          path: '/BeiHuo',
          name: 'BeiHuo',
          component: BeiHuo,
        },
        {
          path: '/Item',
          name: 'Item',
          component: Item,
        },
        {
          path: '/Sku',
          name: 'Sku',
          component: Sku,
        },
        {
          path: '/Permission',
          name: 'Permission',
          component: Permission,
        },
        {
          path: '/Help',
          name: 'Help',
          component: Help,
        },
        {
          path: '/ItmFull',
          name: 'ItmFull',
          component: ItmFull,
        },
        {
          path: '/SkuFull',
          name: 'SkuFull',
          component: SkuFull,
        },
        {
          path: '/Custom',
          name: 'Custom',
          component: Custom,
        },

        {
          path: '/GaoDeng',
          name: 'GaoDeng',
          component: GaoDeng,
        },
        {
          path: '/GaoYao',
          name: 'GaoYao',
          component: GaoYao,
        },
        {
          path: '/JingChu',
          name: 'JingChu',
          component: JingChu,
        },
        {
          path: '/QianShu',
          name: 'QianShu',
          component: QianShu,
        },
        {
          path: '/ManKa',
          name: 'ManKa',
          component: ManKa,
        },
        {
          path: '/Tjfzz',
          name: 'Tjfzz',
          component: Tjfzz,
        },
        {
          path: '/Print',
          name: 'Print',
          component: Print,
        },
        {
          path: '/Wlb',
          name: 'Wlb',
          component: Wlb,
        },
        {
          path: '/Bind',
          name: 'Bind',
          component: Bind,
        },
        {
          path: '/Outer',
          name: 'Outer',
          component: Outer,

        },
        {
          path: '/PrintMd',
          name: 'PrintMd',
          component: PrintMd,

        },
        {
          path: '/KddTemp',
          name: 'KddTemp',
          component: KddTemp,

        },
        {
          path: '/Design',
          name: 'Design',
          component: Design,
        },
        {
          path: '/Print',
          name: 'Print',
          component: Print,
        },
        {
          path: '/ModiSku',
          name: 'ModiSku',
          component: ModiSku,
        },
        {
          path: '/Free',
          name: 'Free',
          component: Free,
        },
        {
          path: '/Refund',
          name: 'Refund',
          component: Refund,
        },
        {
          path: '/Address',
          name: 'Address',
          component: Address,
        },
        {
          path: '/Love',
          name: 'Love',
          component: Love,
        },
        {
          path: '/Material',
          name: 'Material',
          component: Material,
        },
        {
          path: '/JxcItem',
          name: 'JxcItem',
          component: JxcItem,
        },
        {
          path: '/JxcSku',
          name: 'JxcSku',
          component: JxcSku,
        },
        {
          path: '/ShowPrint',
          name: 'ShowPrint',
          component: ShowPrint,
        },
        {
          path: '/AutoSend',
          name: 'AutoSend',
          component: AutoSend,
        },
        {
          path: '/MemoLog',
          name: 'MemoLog',
          component: MemoLog,
        },
        {
          path: '/SendItem',
          name: 'SendItem',
          component: SendItem,
        },
        {
          path: '/AutoMemo',
          name: 'AutoMemo',
          component: AutoMemo,
        },
      ]
    },

  ]
})


router.beforeEach(function (to, form, next) {
  const token = storage.get("token");
  const user = storage.get("nick");


  /*if (to.name.indexOf("Login") < 0) {
    //未登录
    if (!token || !user) {
      router.replace({name: 'Login'}).then(r =>   console.log('catch:'))
    }
  }*/

  /*if(to.name.indexOf("admain")>=0){
    if(!token){
      router.replace({name:'AdmLogin'}).then(r => console.log(r))
    }
  }*/
  //进入主页后直接进入情报板地图页面
  if (to.name === "Main") {
    router.replace({name: 'Index'});
    storage.set("active", "1")
  }

  if (to.name === "AdmMain") {
    router.replace({name: 'AdmAccess'});

  }

  if(to.name === "Custom"){
    if(user === "高灯大师旗舰店"){
      router.replace({name:'GaoDeng'});

    }else if(user === "我是小膏药"){
      router.replace({name:'GaoYao'});

    }else if(user === "jemima88" || user === "早渔人家旗舰店"){
      router.replace({name:'JingChu'});

    }else if(user === "yang15968894410" || user === "yanghuanha" || user === "dumma旗舰店" || user === "米蔓旗舰店" || user === "墙悦旗舰店"){
      router.replace({name:'QianShu'});

    } else if(user === "曼卡印象"){
      //router.replace({name:'ManKa'});

    }else if(user === "tjfzz518") {
      router.replace({name: 'Tjfzz'});
    }else if( (user == "a02_shop") || (user == "妞妞时尚靓衣坊") || (user == "水晶之恋驿站") ){
        router.replace({name:'Tjfzz'});
    }else if(user === "小小威唔多威"){
      router.replace({name:'Tjfzz'});
    }else  if((user == "sauir") || (user == "tbjdwen1") || (user == "mansonwlh") || (user == "流波宝宝")){
      router.replace({name:'ItmFull'});
    }else if((user == "tb004296252")||(user == "tb154416270")){
      router.replace({name:'Wlb'})
    }else if(user == "wgaofa"){
      router.replace({name: 'GaoDeng'})
    }
    else if(user == '惯于艹爱你i'){
      router.replace({name: 'Love'})
    }
  }

  /*if(to.name === "Item"){
    if((user == "sauir") || (user == "tbjdwen1") || (user == "mansonwlh") || (user == "流波宝宝")){
      router.replace({name:'ItmFull'});
    }
  }*/


  /*if(to.name == "GaoDeng"){
    if(user != "高灯大师旗舰店"){
      router.replace({name:'Custom'});
    }
  }*/

  //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  //versionTood.isNewVersion();

  next();
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js